import { FILTER_SECTION } from "web/react/components/filters-emo/filter-utils";
import environment from "web/script/modules/environment";
import {
    OptionFilterOption,
    UniversalFilterOption,
    UniversalFiltersData,
} from "web/types/universal-filters";
import { UsePopularDesignerPills } from "./types";
import { extractSelectedDesignerFromFilters } from "./utils";

export function getPopularDesignerTaxonomyPills(
    filters: UniversalFiltersData
): Pick<UsePopularDesignerPills, "pills" | "designer"> {
    // Extract the selected type filter (if there is) and the available category filters
    const availableProductTypeFilters = filters.filter_section_list.find(
        (section) => section.id === FILTER_SECTION.categoryFilter
    )?.option_groups[0].options as OptionFilterOption[] | undefined;
    const selectedProductTypeFilter = availableProductTypeFilters?.find((filter) => filter.checked);
    const availableCategoryFilters = selectedProductTypeFilter?.children as
        | UniversalFilterOption[]
        | undefined;

    // Extract the selected category filter (if there is) and the available subcategory filters
    const selectedCategoryFilter = selectedProductTypeFilter?.children?.find(
        (child) => child.checked
    );
    const availableSubcategoryFilters = selectedCategoryFilter?.children as
        | UniversalFilterOption[]
        | undefined;

    // In case we don't have such filters selected
    if (!selectedProductTypeFilter && !selectedCategoryFilter) {
        return {
            pills: null,
            designer: null,
        };
    }

    let pills = selectedCategoryFilter ? availableSubcategoryFilters : availableCategoryFilters;

    // If we have specified a list of filters to include only
    // then we need to filter the list and sort it according to the specified filters list
    // but this only applies to the D+T feeds
    const showPopularPillsOnDesignerProfile = environment.getFeature(
        "act_popular_pills_designer_profile_feed"
    );
    const feedPopularCategories = environment.get("feedPopularCategories");
    if (!showPopularPillsOnDesignerProfile && feedPopularCategories && !selectedCategoryFilter) {
        pills = pills
            ?.filter((filter) => feedPopularCategories.includes(filter.value as string))
            .sort(
                (a, b) =>
                    feedPopularCategories.indexOf(a.value as string) -
                    feedPopularCategories.indexOf(b.value as string)
            );
    }

    // Extract designer information to display
    const designer = extractSelectedDesignerFromFilters(filters);

    return {
        pills,
        designer,
    };
}
